import zoomSdk from "@zoom/appssdk";
import LogManager from "./logManager";

// Capabilities the app requests when configuring the Zoom Apps SDK.
const ZOOM_SDK_CAPABILITIES = [
  "getAppContext",
  "getMeetingContext",
  "getRunningContext",
  "getUserContext",
  "openUrl",
  "getMeetingUUID",
  "authorize",
  "onAuthorized",
  "sendMessageToChat",
  "onRTMSStatusChange",
  "getRTMSStatus",
];

/**
 * Configure the Zoom Apps SDK with the app's popout size and required
 * capabilities. Returns the SDK config response.
 */
export const configureZoomSdk = async () => {
  const configResponse = await zoomSdk.config({
    popoutSize: { width: 362, height: 781 },
    capabilities: ZOOM_SDK_CAPABILITIES,
  });
  LogManager.info("Zoom SDK Configured Successfully:", configResponse);
  return configResponse;
};

/**
 * Opens a URL in the Zoom client, logging any failure. Consolidates the
 * try/await/catch block that was previously copy-pasted across the app.
 */
export const openUrl = async (url, errorMessage = "Failed to open URL in Zoom:") => {
  try {
    await zoomSdk.openUrl({ url });
  } catch (error) {
    LogManager.error(errorMessage, error);
  }
};
